import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-gabarito',
  standalone: true,
  imports: [],
  templateUrl: './gabarito.component.html',
  styleUrl: './gabarito.component.scss'
})
export class GabaritoComponent implements OnChanges {
  @Input() gabarito: string | undefined;
  @Input() related: string | undefined;
  @Input() answer: string | undefined;

  safeGabarito: SafeHtml | undefined;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.gabarito || this.gabarito.trim() === '') {
      const resposta = this.answer?.toUpperCase() ?? 'Não informada';
      const html = `<p><strong>A resposta correta é:</strong> ${resposta}</p>`;
      this.safeGabarito = this.sanitizer.bypassSecurityTrustHtml(html);
    } else {
      this.safeGabarito = this.sanitizer.bypassSecurityTrustHtml(this.gabarito);
    }
  }
}
